import {getAllInstancesByName} from "../../core"

function onDisplay(element: HTMLElement, showing: any, notshowing?: any, noinit?: boolean):void {
    const TabLayoutInstances = getAllInstancesByName("TabLayoutParent")
    if(TabLayoutInstances.length) {
        if(notshowing) notshowing()
        let remainingLayout = document.querySelectorAll("[data-tabs]").length;
        if (!remainingLayout) {
                showing();
        } else {
              for(const instance of TabLayoutInstances) {
                remainingLayout--;
                  if (instance.isChild(element)) {
                        instance.doWhenShowing(element, showing, notshowing, noinit);
                  } else {
                      if (!remainingLayout) {
                        showing();
                      }
                  }
              }
        }
    } else {
        showing()
    }
}

export {
    onDisplay
}